"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function ReadyToBook() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        const rect = parallaxRef.current.getBoundingClientRect();
        const elementTop = rect.top + scrolled;
        const offset = (scrolled - elementTop) * 0.3;
        parallaxRef.current.style.transform = `translateY(${offset}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="ready-to-book" ref={ref} className="dark bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-0 will-change-transform bg-[url(/img/luxury_chauffeur_la_skyline_dusk.png)]" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/70 via-primary-dark/50 to-dark-section/90 pointer-events-none" />

      {}
      <div className={`relative z-10 container mx-auto px-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <div className="glass-effect max-w-2xl mx-auto p-10 md:p-14 text-center shadow-strong">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-foreground leading-tight tracking-tight">
            Ready to Book?
          </h2>

          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/bmw_7_series_executive.png" alt="2025 BMW SUV" className="w-full max-w-md mx-auto mb-8 rounded-md" />

          <p className="text-dark-foreground/80 text-lg md:text-xl mb-8 leading-relaxed">
            Experience luxury chauffeur service in Los Angeles. Call or text us to reserve your ride.
          </p>

          {}
          <div className="flex items-center justify-center gap-3 mb-10">
            <Phone className="size-6 text-secondary-dark" aria-hidden="true" />
            <Link to="tel:323-492-6292" className="text-2xl md:text-3xl font-semibold text-foreground hover:text-secondary-dark transition-colors duration-[var(--duration-medium)] focus-ring">
              323-492-6292
            </Link>
          </div>

          {}
          <Button asChild size="lg" className="btn-primary text-base md:text-lg px-10 py-6 shadow-medium hover:shadow-strong hover:scale-[1.02] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
            <Link to="/ContactPage">Reserve Your Ride</Link>
          </Button>
        </div>
      </div>
    </section>;
}